import React, { Component } from "react";
import PropTypes from "prop-types";
import DealerContactInfo from "./DealerContactInfo";
import { withTranslation } from "react-i18next";
import styles from "./DealerShipDetails.module.scss";
import { InfoIconWithMessage } from "../../../shared/infoIcon/InfoIcon";

class DealershipDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderAgain: false,
    };

    this.enableLiveUpdateEmployees = this.enableLiveUpdateEmployees.bind(this);
  }

  enableLiveUpdateEmployees() {
    this.setState({ renderAgain: true });
  }

  disableLiveUpdateEmployees = () => {
    this.setState({ renderAgain: false });
  };

  render() {
    const { filteredDealers, t } = this.props;
    const filteredDealerKeys = Object.keys(filteredDealers);
    const hasFilteredDealers = filteredDealerKeys.length > 0;

    return (
      <>
        <div className="pageInfoWrapper pagePaddingLeft pagePaddingTop pagePaddingRight">
          <InfoIconWithMessage message={t("DealerShipDetails.pageInfo")} />
        </div>
        <div className={`${styles.topPadding} pageWrapper`}>
          {hasFilteredDealers &&
            filteredDealerKeys.map((commonId) => {
              return (
                <DealerContactInfo
                  {...this.props}
                  renderAgain={this.state.renderAgain}
                  disableLiveUpdateEmployees={this.disableLiveUpdateEmployees}
                  dealers={filteredDealers[commonId]}
                  enableLiveUpdateEmployees={this.enableLiveUpdateEmployees}
                  key={commonId}
                />
              );
            })}
        </div>
      </>
    );
  }
}

const dealerShape = PropTypes.shape({
  emailAddress: PropTypes.string,
  phoneNumber: PropTypes.string,
  name: PropTypes.string,
  regionalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  completeDealerId: PropTypes.string,
  paCode: PropTypes.string,
  isOnboarded: PropTypes.bool,
  address: PropTypes.shape({
    street: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    postalCode: PropTypes.string,
  }),
});

DealershipDetails.propTypes = {
  t: PropTypes.func.isRequired,
  filteredDealers: PropTypes.oneOfType([
    PropTypes.arrayOf(dealerShape),
    PropTypes.objectOf(dealerShape),
  ]),
};

DealershipDetails.defaultProps = {
  filteredDealers: {},
};

export default withTranslation("emp")(DealershipDetails);
